/**
 * IMPORTS
 */

const env = import.meta.env.VITE_ENV;

const BASE_API =
  env === "DEV" ? import.meta.env.VITE_APP_URL_DEV : import.meta.env.VITE_APP_URL_PROD;

const BACKOFFICE_URL = import.meta.env.VITE_BACKOFFICE_URL ?? "";

export { BASE_API, BACKOFFICE_URL };
